import type { ReactNode } from "react";
import { Spinner } from "./Spinner.js";

/**
 * Cztery stany widoku (P-6) w jednej rodzinie komponentow (MG-5).
 *
 * S-5: kazdy z nich renderuje sie WEWNATRZ karty sekcji, w ktorej pojawia sie dane.
 * Karta nie znika przy braku danych (L-8) - widok pusty ma byc tak samo ulozony
 * jak pelny.
 */

/** S-6 plus PR-5: komunikat czytany przez czytnik ekranu, bo sam spinner jest aria-hidden. */
export function StanLadowania({ tekst = "Wczytuję..." }: { tekst?: string }): React.JSX.Element {
  return (
    <div className="state-loading" role="status" aria-live="polite">
      <Spinner rozmiar="l" />
      <p className="state-loading__text">{tekst}</p>
    </div>
  );
}

/**
 * S-8: stan pusty. CP-7 chce zachety, nie samego stwierdzenia faktu, wiec `opis`
 * mowi, co zrobic dalej, a nie tylko czego nie ma.
 */
export function StanPusty({
  tytul,
  opis,
  ikona,
  akcja,
}: {
  tytul: string;
  opis?: string;
  ikona?: ReactNode;
  akcja?: ReactNode;
}): React.JSX.Element {
  return (
    <div className="state-empty">
      {ikona && (
        <div className="state-empty__icon-wrap" aria-hidden="true">
          {ikona}
        </div>
      )}
      <p className="state-empty__title">{tytul}</p>
      {opis && <p className="state-empty__desc">{opis}</p>}
      {akcja}
    </div>
  );
}

/**
 * S-9: karta bledu. S-1 (po ludzku), S-2 (identyfikowalny), S-3 (podpowiada, co dalej).
 * `szczegol` niesie kod techniczny - dla nas, nie dla klienta, dlatego jest wyciszony
 * i osobno od zdania wyjasniajacego.
 */
export function StanBledu({
  tytul = "Nie udało się wczytać danych",
  opis = "Spróbuj ponownie za chwilę. Jeśli problem wraca, daj nam znać.",
  szczegol,
  akcja,
}: {
  tytul?: string;
  opis?: string;
  szczegol?: string;
  akcja?: ReactNode;
}): React.JSX.Element {
  return (
    <div className="state-error" role="alert">
      <div className="state-error__icon-wrap" aria-hidden="true">
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 8v5" />
          <path d="M12 16h.01" />
        </svg>
      </div>
      <p className="state-error__title">{tytul}</p>
      <p className="state-error__desc">{opis}</p>
      {szczegol && <p className="state-error__detail">{szczegol}</p>}
      {akcja}
    </div>
  );
}
